import React, { Fragment, useState } from "react";
import AdminLayout from "../layout";
import GalleryMenu from "./GalleryMenu";
import AllGallery from "./AllGallery";

const GalleryComponent = () => {
  const [flag, setFlag] = useState(0);

  const onUploaded = () => setFlag((f) => f + 1);

  return (
    <div className="grid grid-cols-1 space-y-4 p-4">
      <div className="grid md:grid-cols-2 gap-4">
        <GalleryMenu onUploaded={onUploaded} />
        <AllGallery refreshFlag={flag} />
      </div>
    </div>
  );
};

const Gallery = (props) => {
  return (
    <Fragment>
      <AdminLayout children={<GalleryComponent />} />
    </Fragment>
  );
};

export default Gallery;
